import { camundaApi } from "@/core/api/camundaApi";

const hasEventBeenTriggered = async (event: string): Promise<boolean> => {
  const result = await camundaApi.getVariablesForProcess([event]);
  const { data } = result;
  const eventData = data[event];
  return !!eventData?.value;
};

const pushEventTriggeredSignal = async (event: string) => {
  await camundaApi.updateProcessVariables({
    [event]: {
      value: true,
      type: "Boolean",
    },
  });
};

export { hasEventBeenTriggered, pushEventTriggeredSignal };
